export type { ListNewsProps } from './News'
export { default as ListNews } from './News'
